module.exports = __webpack_public_path__ + "img/solar.50294300.png";